import Link from 'next/link';
import cx from 'classnames';

import ArrowRight from 'assets/svg/arrow-right.svg';

import styles from './Crumb.module.scss';

import type { CrumbProps } from './types';

const Crumb: React.FC<CrumbProps> = ({
  route,
  isActive,
  showArrow,
  ...rest
}) => {
  const containerClass = cx(styles.container, {
    [styles.active]: isActive,
  });

  const arrowClass = cx(styles.arrow, {
    [styles.active]: isActive,
  });

  return (
    <>
      {showArrow && <ArrowRight className={arrowClass} />}
      <li className={containerClass}>
        {route.href ? (
          <Link href={route.href}>
            <a {...rest}>{route.name}</a>
          </Link>
        ) : (
          <span {...rest}>{route.name}</span>
        )}
      </li>
    </>
  );
};

export default Crumb;
